.Expander_Expander_79ceb47{max-height:0;overflow:hidden;will-change:height}